import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { setAdditionalServices, Value } from '../Utils/setAdditionalServices';

import { finCalcDataAtom } from './FinCalcData.atom';
import { deepGet } from '@core/Utils/DeepGet';
import { deepSet } from '@core/Utils/DeepSet';
import { isWindowDefined } from '@core/Constants/Window';

export const finCalcDataFieldValueAtom = atomFamily((fieldId: string) =>
  atom(
    get => {
      const finCalcData = get(finCalcDataAtom);

      // @ts-expect-error - window object does not have this type
      if (isWindowDefined) window.finCalcData = finCalcData;

      return deepGet(finCalcData, fieldId);
    },
    (get, set, value) => {
      let newData = deepSet(get(finCalcDataAtom), fieldId, value);

      if (fieldId === 'additionalServices')
        newData = setAdditionalServices(newData, value as Value);

      set(finCalcDataAtom, newData);
    },
  ),
);
